const menuButton = document.getElementById("menuButton");
const menuLayer = document.querySelector(".menu_layer");
const menuLinks = document.querySelectorAll(".menu_item a"); // メニュー内のリンクを取得
let isMenuOpened = false;

function toggleMenu() {
  isMenuOpened = !isMenuOpened;
  if (isMenuOpened) {
    // メニューを開いた時の処理
    menuButton.classList.add("is-opened");
    menuLayer.classList.add("open");
    menuButton.setAttribute("aria-expanded", "true"); // aria-expanded を true に設定
    document.body.style.overflow = "hidden"; // スクロールを禁止
  } else {
    // メニューを閉じた時の処理
    menuButton.classList.remove("is-opened");
    menuLayer.classList.remove("open");
    menuButton.setAttribute("aria-expanded", "false"); // aria-expanded を false に設定
    document.body.style.overflow = ""; // スクロールを元に戻す
  }
}

function handleResize() {
  if (window.innerWidth >= 1001) {
    // 幅が768px以上の場合、クラスを削除
    isMenuOpened = false;
    menuButton.classList.remove("is-opened");
    menuLayer.classList.remove("open");
    document.body.style.overflow = ""; // スクロールを元に戻す
  }
}

// 同じページ内ジャンプリンクをクリックしたときにメニューを閉じる
menuLinks.forEach((link) => {
  link.addEventListener("click", (event) => {
    const href = link.getAttribute("href");
    const currentPath = location.pathname.replace(/\/$/, ""); // 末尾のスラッシュを削除
    const linkPath = link.pathname.replace(/\/$/, ""); // 末尾のスラッシュを削除
    if (
      href &&
      href.includes("#") &&
      (linkPath === currentPath || linkPath === "")
    ) {
      // 同じページ内のリンクの場合のみメニューを閉じる
      isMenuOpened = false;
      menuButton.classList.remove("is-opened");
      menuLayer.classList.remove("open");
      document.body.style.overflow = ""; // スクロールを元に戻す
    }
  });
});

menuButton.addEventListener("click", toggleMenu);
window.addEventListener("resize", handleResize);
